export default __webpack_public_path__ + "static/media/approval.fe5a2e9e.svg";